import React from "react";
import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import type { ProcessingStatus } from "../../types";

interface BackgroundProcessingIndicatorProps {
  status: ProcessingStatus;
}

export const BackgroundProcessingIndicator: React.FC<
  BackgroundProcessingIndicatorProps
> = ({ status }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        position: "fixed",
        bottom: 90,
        right: 24,
        zIndex: 1200,
        minWidth: 300,
        maxWidth: 380,
        p: 2,
        borderRadius: 2,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
        Processing Case
      </Typography>

      <Box sx={{ mb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {status.currentStep}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={status.progress}
          sx={{ height: 6, borderRadius: 3 }}
        />
      </Box>

      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        The case will appear in the grid when complete.
      </Typography>
    </Paper>
  );
};
